import React, { useState, useEffect, useRef } from "react";

import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, } from "swiper/modules";

import febCalendar from "@/public/images/calendar/menfis_calendar_feb.jpg";
import marchCalendar from "@/public/images/calendar/menfis_calendar_march.png";
import aprCalendar from "@/public/images/calendar/menfis_calendar_apr.png";
import mayCalendar from "@/public/images/calendar/menfis_calendar_may.png";
import augCalendar from "@/public/images/calendar/menfis_calendar_aug.png";
import sepCalendar from "@/public/images/calendar/menfis_calendar_sep.png";
import octCalendar from "@/public/images/calendar/menfis_calendar_oct.png";
import novCalendar from "@/public/images/calendar/menfis_calendar_nov.png";


const CalendarBanner = () => {
  const thumbsSwiperRef = useRef(null);

  return (
    <>
      <Swiper
        className="swiper rbt-banner-activation rbt-slider-animation calendar-swiper rbt-arrow-between"
        modules={[FreeMode, Navigation ]}
        ref={thumbsSwiperRef}
        slidesPerView={1}
        spaceBetween={0}
        loop={true}
        autoHeight={false}
        navigation={{
          nextEl: ".rbt-arrow-left",
          prevEl: ".rbt-arrow-right",
          clickable: true,
        }}
      >
        <div className="swiper-wrapper">
        <SwiperSlide className="swiper-slide">
          <div className="rbt-banner-area rbt-banner-6 variation-02">
            <Image
              src={novCalendar}
              width={1240}
              height={750}
              alt="november calendar"
            />
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div className="rbt-banner-area rbt-banner-6 variation-02">
            <Image
              src={octCalendar}
              width={1240}
              height={750}
              alt="october calendar"
            />
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div className="rbt-banner-area rbt-banner-6 variation-02">
            <Image
              src={sepCalendar}
              width={1240}
              height={750}
              alt="september calendar"
            />
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div className="rbt-banner-area rbt-banner-6 variation-02">
            <Image
              src={augCalendar}
              width={1240}
              height={750}
              alt="august calendar"
            />
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div className="rbt-banner-area rbt-banner-6 variation-02">
            <Image
              src={mayCalendar}
              width={1240}
              height={750}
              alt="may calendar"
            />
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div className="rbt-banner-area rbt-banner-6 variation-02">
            <Image
              src={aprCalendar}
              width={1240}
              height={750}
              alt="april calendar"
            />
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div className="rbt-banner-area rbt-banner-6 variation-02">
            <Image
              src={marchCalendar}
              width={1240}
              height={750}
              alt="march calendar"
            />
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div className="rbt-banner-area rbt-banner-6 variation-02">
            <Image
              src={febCalendar}
              width={1240}
              height={750}
              alt="february calendar"
            />
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div className="rbt-banner-area rbt-banner-6 variation-02">
            <Image
              src={novCalendar}
              width={1240}
              height={750}
              alt="november calendar"
            />
          </div>
        </SwiperSlide>
          
        </div>
        <div className="rbt-swiper-arrow rbt-arrow-left">
          <div className="custom-overfolow">
            <i className="rbt-icon feather-arrow-left"></i>
            <i className="rbt-icon-top feather-arrow-left"></i>
          </div>
        </div>

        <div className="rbt-swiper-arrow rbt-arrow-right">
          <div className="custom-overfolow">
            <i className="rbt-icon feather-arrow-right"></i>
            <i className="rbt-icon-top feather-arrow-right"></i>
          </div>
        </div>
      </Swiper>

    </>
  );
};

export default CalendarBanner;
